// extracted by mini-css-extract-plugin
module.exports = {"white-color":"#ffffff"};